import { SOLR_SEARCH } from 'parmasottositi-theme/constants/ActionTypes';

export function solrSearch(params) {
  let searcherUrl =
    (__CLIENT__ && window.env.RAZZLE_SOLR_SEARCHER_URL) ||
    process.env.RAZZLE_SOLR_SEARCHER_URL ||
    '';
  if (searcherUrl && searcherUrl[searcherUrl.length - 1] !== '/') {
    searcherUrl = searcherUrl + '/';
  }

  return {
    type: SOLR_SEARCH,
    request: {
      op: 'get',
      path: `${searcherUrl}search`,
      params,
    },
  };
}

export function resetSolrSearch() {
  return {
    type: `${SOLR_SEARCH}_RESET`,
  };
}
